import { jwtDecode } from "jwt-decode";
// import { config } from "../config";

export const validateToken = (token, config) => {
    // debugger;
    try {
      /* const localhostUrl = 'localhost';
      if (window.location.hostname.toLowerCase() === localhostUrl.toLowerCase()) {
        return true;
      } */

      // Decode the token
      const decodedToken = jwtDecode(token);
  
      // Validate issuer
      const expectedIssuer = config.issuer;
      if (decodedToken.iss !== expectedIssuer) {
        return ("Invalid token issuer");
      }
  
      // Validate audience
      const expectedAudience = config.clientId;
      if (decodedToken.aud !== expectedAudience) {
        return ("Invalid token audience");
      }
  
      // Check token expiration
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp < currentTime) {
        return ("Token has expired");
      }

      
      return true;
    } catch (error) {
      console.error("Token validation failed:", error.message);
    }
};


/* 
export const validateToken = (token, config) => {
 return true;
}; */